module.exports = "/img/_/_/_/assets/images/creeper/book/uncommon//21.jpg?bcc254ff81b6134da29b146cffb1d0ba";